import React, { useEffect } from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import {
  FormControlLabel,
  FormLabel,
  Modal,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography
} from '@material-ui/core';
import { connect } from 'react-redux';
import CancelButton from '../atoms/CancelButton';
import ConfirmButton from '../atoms/ConfirmButton';
import BackButton from '../atoms/BackButton';
import RegisterButton from '../atoms/RegisterButton';
import RequiredButton from '../atoms/RequiredButton';

const styles = {
  modal: {
    maxWidth: 880,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  contentContainer: {
    padding: 40,
    backgroundColor: '#fff',
    borderRadius: 4
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 5
  },
  description: {
    display: 'block',
    fontSize: 18,
    marginBottom: 20
  },
  fs14: {
    fontSize: 14
  },
  radioGroup: {
    marginBottom: 10
  },
  buttonContainer: {
    marginTop: 16
  },
  detailTable: {
    marginTop: 48
  },
  tableCell: {
    padding: '0 0 16px',
    border: 'none'
  },
  detailTableComfirm: {
    margin: '48px 0'
  },
  tableCellConfirm: {
    borderTop: '1px solid rgba(224, 224, 224, 1)',
    padding: '16px 12px'
  },
  tableCellTitleConfirm: {
    backgroundColor: '#F7F7F7',
    fontWeight: 700,
    width: 130
  }
};

const enhance = compose(
  connect(
    state => ({
      shops: state.shops.shops
    }),
    () => ({})
  ),
  withState('newGochiKidFlag', 'setNewGochiKidFlag', 0),
  withState('newGochiKidQrFlag', 'setNewGochiKidQrFlag', 0),
  withState('joinGochiKidFlag', 'setJoinGochiKidFlag', 0),
  withState('isConfirm', 'setIsConfirm', false)
);

const button = enhance(
  ({
    classes,
    open,
    onClose,
    newGochiKidFlag,
    setNewGochiKidFlag,
    newGochiKidQrFlag,
    setNewGochiKidQrFlag,
    joinGochiKidFlag,
    setJoinGochiKidFlag,
    isConfirm,
    setIsConfirm,
    updateShopGochiKidFlag
  }) => {
    useEffect(() => {
      if (open) {
        setIsConfirm(false);
        setNewGochiKidFlag(0);
        setNewGochiKidQrFlag(0);
        setJoinGochiKidFlag(0);
      }
    }, [open]);

    const handleChangeJoinGochiKidFlag = value => {
      if (value === 0) {
        setNewGochiKidFlag(0);
        setNewGochiKidQrFlag(0);
      } else if (value === 1) {
        setNewGochiKidFlag(1);
        setNewGochiKidQrFlag(1);
      } else if (value === 2) {
        setNewGochiKidFlag(1);
        setNewGochiKidQrFlag(0);
      }
      setJoinGochiKidFlag(value);
    };

    const getTextJoinGochiKidFlag = () => {
      let text = '';

      if (joinGochiKidFlag === 0) text = '参加しない';
      else if (joinGochiKidFlag === 1)
        text = '参加する(カード型会員証対応あり)';
      else if (joinGochiKidFlag === 2)
        text = '参加する(カード型会員証対応なし)';

      return text;
    };

    return (
      <>
        <Modal open={open} onClose={onClose} className={classes.modal}>
          {!isConfirm ? (
            <div className={classes.contentContainer}>
              <Typography className={classes.title} variant="h6">
                一括こどもごちめし参加設定
              </Typography>
              <Table className={classes.detailTable}>
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.tableCell}>
                      <RequiredButton />
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <FormLabel className={classes.fs14}>
                        一括こどもごちめし参加設定*
                      </FormLabel>
                      <RadioGroup
                        value={joinGochiKidFlag}
                        onChange={e => {
                          handleChangeJoinGochiKidFlag(
                            parseInt(e.target.value, 10)
                          );
                        }}
                        className={classes.radioGroup}
                      >
                        <FormControlLabel
                          value={0}
                          control={<Radio color="primary" />}
                          label={
                            <Typography style={{ fontWeight: 'bolder' }}>
                              参加しない
                            </Typography>
                          }
                        />
                        <FormControlLabel
                          value={1}
                          control={<Radio color="primary" />}
                          label={
                            <Typography style={{ fontWeight: 'bolder' }}>
                              参加する(カード型会員証対応あり)
                            </Typography>
                          }
                        />
                        <FormControlLabel
                          value={2}
                          control={<Radio color="primary" />}
                          label={
                            <Typography style={{ fontWeight: 'bolder' }}>
                              参加する(カード型会員証対応なし)
                            </Typography>
                          }
                        />
                      </RadioGroup>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <div className={classes.buttonContainer}>
                <CancelButton onClickAction={onClose} color="primary" />
                <ConfirmButton
                  onClickAction={() => {
                    setIsConfirm(true);
                  }}
                />
              </div>
            </div>
          ) : (
            <div className={classes.contentContainer}>
              <Typography className={classes.title} variant="h6">
                一括こどもごちめし参加設定 確認
              </Typography>
              <Table className={classes.detailTableComfirm}>
                <TableBody>
                  <TableRow>
                    <TableCell
                      className={[
                        classes.tableCellConfirm,
                        classes.tableCellTitleConfirm
                      ]}
                    >
                      一括こどもごちめし参加設定
                    </TableCell>
                    <TableCell className={classes.tableCellConfirm}>
                      {getTextJoinGochiKidFlag()}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <div className={classes.buttonContainer}>
                <BackButton
                  onClickAction={() => {
                    setIsConfirm(false);
                  }}
                />
                <RegisterButton
                  onClickAction={() =>
                    updateShopGochiKidFlag(newGochiKidFlag, newGochiKidQrFlag)
                  }
                />
              </div>
            </div>
          )}
        </Modal>
      </>
    );
  }
);

export default withStyles(styles)(button);
